export function validatePassword(password: string): { isValid: boolean; error: string } {
  if (password.length < 6) {
    return { isValid: false, error: "Password must be at least 6 characters" };
  }
  return { isValid: true, error: "" };
}

export function validatePasswordConfirmation(
  password: string,
  confirmPassword: string,
): { isValid: boolean; error: string } {
  const passwordValidation = validatePassword(password);
  if (!passwordValidation.isValid) {
    return passwordValidation;
  }
  if (password !== confirmPassword) {
    return { isValid: false, error: "Passwords do not match" };
  }
  return { isValid: true, error: "" };
}
